import React from 'react';

function Paragraph(props) {
	const fill = props.fill || 'currentColor';
	const secondaryfill = props.secondaryfill || fill;
	const strokewidth = props.strokewidth || 1;
	const width = props.width || '1em';
	const height = props.height || '1em';

	return (
		<svg height={height} width={width} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<g fill={fill} strokeLinecap="butt" strokeLinejoin="miter">
		<rect height="6" width="6" fill="none" rx="1" ry="1" stroke={fill} strokeLinecap="square" strokeMiterlimit="10" strokeWidth={strokewidth} x="3" y="3"/>
		<rect height="6" width="6" fill="none" rx="1" ry="1" stroke={fill} strokeLinecap="square" strokeMiterlimit="10" strokeWidth={strokewidth} x="3" y="15"/>
		<line fill="none" stroke={secondaryfill} strokeLinecap="square" strokeMiterlimit="10" strokeWidth={strokewidth} x1="14" x2="21" y1="4" y2="4"/>
		<line fill="none" stroke={secondaryfill} strokeLinecap="square" strokeMiterlimit="10" strokeWidth={strokewidth} x1="14" x2="21" y1="8" y2="8"/>
		<line fill="none" stroke={secondaryfill} strokeLinecap="square" strokeMiterlimit="10" strokeWidth={strokewidth} x1="14" x2="21" y1="16" y2="16"/>
		<line fill="none" stroke={secondaryfill} strokeLinecap="square" strokeMiterlimit="10" strokeWidth={strokewidth} x1="14" x2="21" y1="20" y2="20"/>
	</g>
</svg>
	);
};

export default Paragraph;